import { FormTextInput } from '@src/common/components/FormTextInput';
import { Stack } from '@src/common/components/Stack';
import { theme } from '@src/common/styles/Theme';
import type { CollapseListener } from '@src/orders/CollapseListener';
import { EditOrderCollapsible } from '@src/orders/EditOrderCollapsible';
import { useSectionError } from '@src/orders/hooks/useSectionError';
import { useDisabledFields } from '@src/orders/PermitFormSections/useDisabledFields';
import {
  orderInformationFields,
  PermitContactEmailAddressField,
  PermitContactNameField,
  PermitContactPhoneField,
} from '@src/permitField/PermitDeliveryAndNotificationsFields';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ConditionalField } from '../ConditionalField';

type Props = CollapseListener & { fields: string[] };
export const OrderInformationSection = (props: Props) => {
  const { t } = useTranslation();
  const { isFieldDisabled } = useDisabledFields();

  const {
    register,
    formState: { errors, disabled: formDisabled },
  } = useFormContext();

  const { sectionInError } = useSectionError(
    Object.keys(orderInformationFields),
  );

  if (props.fields.length === 0) {
    return null;
  }

  return (
    <EditOrderCollapsible
      title={t('orderInformation')}
      collapseEventName={props.collapseEventName}
      uncollapseEventName={props.uncollapseEventName}
      inError={sectionInError}
    >
      <Stack gap={theme.spacing['3']}>
        <Stack direction="row" gap={theme.spacing['3']}>
          <ConditionalField
            fields={props.fields}
            conditions={PermitContactNameField.fieldName}
          >
            <FormTextInput
              register={register}
              errors={errors}
              fieldName={PermitContactNameField.fieldName}
              disabled={
                formDisabled ||
                isFieldDisabled(PermitContactNameField.fieldName)
              }
            />
          </ConditionalField>
          <ConditionalField
            fields={props.fields}
            conditions={PermitContactPhoneField.fieldName}
          >
            <FormTextInput
              register={register}
              errors={errors}
              fieldName={PermitContactPhoneField.fieldName}
              disabled={
                formDisabled ||
                isFieldDisabled(PermitContactPhoneField.fieldName)
              }
            />
          </ConditionalField>
        </Stack>

        <ConditionalField
          fields={props.fields}
          conditions={PermitContactEmailAddressField.fieldName}
        >
          <FormTextInput
            register={register}
            errors={errors}
            fieldName={PermitContactEmailAddressField.fieldName}
            disabled={
              formDisabled ||
              isFieldDisabled(PermitContactEmailAddressField.fieldName)
            }
          />
        </ConditionalField>
      </Stack>
    </EditOrderCollapsible>
  );
};
